import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import OverallPerformance from 'components/data-containers/Overview/OverallPerformance/OverallPerformance';
import OverviewSections from 'components/data-containers/Overview/OverviewSections/OverviewSection';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';

import { checkIsExternalUser } from 'redux/reducers/authentication';
import { EntityContext } from 'context/entityContext';

const PerformanceSummary: React.FC = () => {
  const ctx = React.useContext(EntityContext);
  const { compareMode } = ctx;
  const isCompare = Boolean(compareMode);
  const [isModalShown, setShowModal] = useState(false);

  const isExternalUser = useSelector(checkIsExternalUser);

  if (isCompare) {
    return (
      <Layout.MaxWidth>
        <Message>Overview cards do not support compare mode.</Message>
      </Layout.MaxWidth>
    );
  }

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      {!isExternalUser && <OverallPerformance showModal={setShowModal} />}

      <OverviewSections
        setShowModal={setShowModal}
        isModalShown={isModalShown}
      />
    </div>
  );
};

export default PerformanceSummary;
